import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import dateSelectionReducer from '../../modules/dateSelection/store/slice';
import seatSelectionReducer from '../../modules/seatSelection/store/slice';
import navigationReducer from '../navigate/store/slice';
import checkoutReducer from '../../modules/checkout/store/slice';

// Корневой редьюсер
const rootReducer = combineReducers({
  dateSelection: dateSelectionReducer,
  seatSelection: seatSelectionReducer,
  navigation: navigationReducer,
  checkout: checkoutReducer,
});

// Конфигурируем хранилище
export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false, // Отключаем проверку на сериализуемость для поддержки более сложных объектов
    }),
  devTools: import.meta.env.DEV, // Включаем Redux DevTools в режиме разработки
});

// Типы для TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Хук для типизированного диспетчера
export const useAppDispatch: () => AppDispatch = () => useDispatch();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
